module.exports = __webpack_public_path__ + "static/media/like.12aa4dc6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/like.svg
// module id = 36
// module chunks = 0